export default __webpack_public_path__ + "static/media/freeWifi.1eb2fc97.svg";